import * as React from 'react';
import { connect } from '@cian/adfox-component';
import { AdFoxTemplates } from '@cian/adfox-templates';
import { useSelector } from 'react-redux';
import { ApplicationContext } from '../../utils/applicationContext';
import { GenericError } from '@cian/peperrors/shared';
import { selectPuids } from '../../selectors/adfox';

export const AdfoxPixelContainer = () => {
  const Adfox = connect(AdFoxTemplates);
  const { logger } = React.useContext(ApplicationContext);
  const puids = useSelector(selectPuids);

  if (!puids) {
    return null;
  }

  const onStubHandle = () => {
    logger.error(
      new GenericError({
        domain: 'AdfoxPixel',
        type: 'Adfox',
        message: 'adfoxStub',
        details: { developerId: puids.puid39 },
      }),
    );
  };

  const onErrorHandle = (event: { type: string }) => {
    logger.error(
      new GenericError({
        domain: 'AdfoxPixel',
        type: 'Adfox',
        message: event.type,
        details: { developerId: puids.puid39 },
      }),
    );
  };

  return (
    <Adfox
      onError={onErrorHandle}
      onStub={onStubHandle}
      params={{ p1: 'cyrbe', p2: 'frfe', ...puids }}
      width="1"
      height="1"
    />
  );
};
